import React, { useEffect, useState } from "react";

import io from "socket.io-client";
import { ToastContainer, toast } from "react-toastify";
import { useEyeconxStore } from '../../store/eyeconxStore';
import notificationSound from './notification1.mp3'; // Assuming the sound file is in the same directory
import {parseIncomingNotification} from '../smsgateway/pages/notifications/notificationUtils';

const ServerNotifications = ({ clinicId }) => {
  const [message, setMessage] = useState(null); // State to store the notification message
  const [notifications, setNotifications] = useState(() => {
    // Get the notifications from localStorage when the component mounts
    const savedNotifications = localStorage.getItem("notifications");
    return savedNotifications ? JSON.parse(savedNotifications) : [];
  });
  // Initialize the Socket.IO client
  const serverUrl = process.env.REACT_APP_NOTIFICATION_SERVER_URL;
  const incrementNotifications = useEyeconxStore((state) => state.incrementNotifications)
  const incrementSmsInbox = useEyeconxStore((state) => state.incrementSmsInbox)
  useEffect(() => {
   // console.log("Connecting to server:", serverUrl);
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    if (isLocalhost) {
      console.log("🔕 Notifications are disabled in localhost environment.");
      return;
    }
    const socket = io(serverUrl); // Replace with your server URL
    const audio = new Audio(notificationSound);
    socket.on("connect", () => {
      console.log("Connected to notficication server with Clinic " + clinicId);
    });
    // Emit an event to the server to join the room for the clinic ID
    socket.emit("registerClinic", clinicId);

    // Listen for the 'notification' event for this clinic room
    socket.on("notification", (data) => {
      const newNotification = parseIncomingNotification(data);
      incrementNotifications();
      incrementSmsInbox();
      // Use the functional form of setNotifications to ensure the state is updated correctly
      setNotifications((prevNotifications) => {
        const updatedNotifications = [...prevNotifications, newNotification];
        // Save the updated notifications array to localStorage
        localStorage.setItem('notifications', JSON.stringify(updatedNotifications));
        return updatedNotifications;
      });
      audio.play();
    });

    // Cleanup when the component is unmounted
    return () => {
      socket.off("notification"); // Unsubscribe from the notification event
      socket.emit("leaveClinicRoom", clinicId); // Leave the room when unmounting
      socket.close();
    };
  }, [clinicId,serverUrl]); // Re-run this effect whenever the clinic ID changes

  return (
    <div>
      <ToastContainer position="top-right" />
    </div>
  );
};

export default ServerNotifications;
